import React from 'react';
import { Route } from "react-router-dom";
import { BrowserRoutes } from "./BrowserRouter";
import Dashboard from "../containers/Dashboard/Dashboard";
import UsersContainer from "../containers/Users/Users.container";
import {ROLES} from "../settings";
import ContractReportsContainer from "../containers/Reports.Contract/Reports.Contract.container";
import OfficersReportContainer from "../containers/Reports.Officer/Reports.Officer.container";
import OpportunityReportsContainer from "../containers/Reports.Opportunity/Reports.Opportunity";
import DataSyncContainer from "../containers/Data.sync/Data.sync";
import SettingsContainer from "../containers/Settings/Settings";
import AlertsContainer from "../containers/Alerts/Alerts.container";
import ContractContainer from "../containers/Contract/Contract.container";
import OpportunityContainer from "../containers/Opportunity/Opportunity.container";
import OfficerContainer from "../containers/Officer/Officer.container";
import AlertContainer from "../containers/Alert/Alert.container";
import {
    AlertOutlined,
    AuditOutlined,
    LayoutOutlined, SettingOutlined, SolutionOutlined,
    SyncOutlined,
    TeamOutlined,
    TrophyOutlined
} from "@ant-design/icons";

export enum EAppSidebarGroups {
    General = 'General',
    Hidden = 'Hidden',
    Management = 'Management',
    Reporting = 'Reports',
}

export const AppRoutesObject = {
    'Dashboard': {
        render: <Route key={0} exact path={BrowserRoutes.home + '/'} component={Dashboard}/>,
        path: BrowserRoutes.home,
        icon: <LayoutOutlined/>,
        group: EAppSidebarGroups.General,
        access: [ROLES.CLIENT, ROLES.CLIENT_PREFERRED]
    },
    'Users': {
        render: <Route key={1} exact path={[BrowserRoutes.usersTabbedParam, BrowserRoutes.usersParam, BrowserRoutes.users]} component={UsersContainer}/>,
        path: BrowserRoutes.users,
        icon: <TeamOutlined/>,
        group: EAppSidebarGroups.Management,
        access: [ROLES.ADMIN, ROLES.SALES]
    },
    'Alerts': {
        render: <Route key={2} exact path={BrowserRoutes.alerts} component={AlertsContainer}/>,
        path: BrowserRoutes.alerts,
        icon: <AlertOutlined/>,
        group: EAppSidebarGroups.Management,
        access: [ROLES.CLIENT, ROLES.CLIENT_PREFERRED]
    },
    'Data Sync': {
        render: <Route key={3} exact path={BrowserRoutes.dataSync} component={DataSyncContainer}/>,
        path: BrowserRoutes.dataSync,
        icon: <SyncOutlined/>,
        group: EAppSidebarGroups.Management,
        access: [ROLES.ADMIN]
    },
    'Contracts': {
        render: <Route key={4} exact path={BrowserRoutes.contracts} component={ContractReportsContainer}/>,
        path: BrowserRoutes.contracts,
        icon: <TrophyOutlined/>,
        group: EAppSidebarGroups.Reporting,
        access: [ROLES.ADMIN, ROLES.SALES, ROLES.CLIENT_PREFERRED]
    },
    'SingleContract': {
        render: <Route key={5} exact path={BrowserRoutes.contractsByIdParam} component={ContractContainer}/>,
        path: BrowserRoutes.contracts,
        icon: null,
        access: [ROLES.CLIENT, ROLES.ADMIN, ROLES.SALES, ROLES.CLIENT_PREFERRED],
        hide:true,
    },
    'Opportunities': {
        render: <Route key={6} exact path={BrowserRoutes.opportunities} component={OpportunityReportsContainer}/>,
        path: BrowserRoutes.opportunities,
        icon: <AuditOutlined/>,
        group: EAppSidebarGroups.Reporting,
        access: [ROLES.ADMIN, ROLES.SALES, ROLES.CLIENT_PREFERRED]
    },
    'SingleOpportunity': {
        render: <Route key={7} exact path={BrowserRoutes.opportunitiesByIdParam} component={OpportunityContainer}/>,
        path: BrowserRoutes.opportunities,
        icon: null,
        access: [ROLES.CLIENT, ROLES.ADMIN, ROLES.SALES, ROLES.CLIENT_PREFERRED],
        hide: true
    },
    'Officers': {
        render: <Route key={8} exact path={BrowserRoutes.officers} component={OfficersReportContainer}/>,
        path: BrowserRoutes.officers,
        icon: <SolutionOutlined/>,
        group: EAppSidebarGroups.Reporting,
        access: [ROLES.ADMIN]
    },
    'SingleOfficer': {
        render: <Route key={9} exact path={BrowserRoutes.officersByIdParam} component={OfficerContainer}/>,
        path: BrowserRoutes.officers,
        icon: null,
        access: [ROLES.CLIENT, ROLES.SALES],
        hide: true,
    },
    'Settings': {
        render: <Route key={10} exact path={BrowserRoutes.settings} component={SettingsContainer}/>,
        path: BrowserRoutes.settings,
        icon: <SettingOutlined/>,
        hide:true,
    },
    'SingleAlert': {
        render: <Route key={11} exact path={BrowserRoutes.alertByIdParam} component={AlertContainer}/>,
        path: BrowserRoutes.alerts,
        icon: null,
        group: EAppSidebarGroups.Management,
        access: [ROLES.CLIENT, ROLES.ADMIN],
        hide:true,
    }
};